import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'directionTranslator'
})
export class DirectionTranslatorPipe implements PipeTransform {

  private translations = {
    'he': {
      'דר': 'S',    // South
      'מע': 'W',    // West
      'צפ': 'N',    // North
      'מז': 'E',    // East
      'דר מע': 'SW', // Southwest
      'דר מז': 'SE', // Southeast
      'צפ מע': 'NW', // Northwest
      'צפ מז': 'NE', // Northeast
      'דר-מע': 'SW', // Southwest (with dash)
      'דר-מז': 'SE', // Southeast (with dash)
      'צפ-מע': 'NW', // Northwest (with dash)
      'צפ-מז': 'NE',  // Northeast (with dash)
      'צ מע' : 'NW',
      'צ מז' : 'NE',
      'ד מז' : 'SE',
      'ד מע': 'SW',
      'דרום' : 'S'
    },
    'en': {
      'S': 'S',
      'W': 'W',
      'N': 'N',
      'E': 'E',
      'SW': 'SW',
      'SE': 'SE',
      'NW': 'NW',
      'NE': 'NE'
    },
    'french': {
      'S': 'Sud',
      'W': 'Ouest',
      'N': 'Nord',
      'E': 'Est',
      'SW': 'Sud-Ouest',
      'SE': 'Sud-Est',
      'NW': 'Nord-Ouest',
      'NE': 'Nord-Est'
    }
  };

  transform(value: string, targetLang: string): string {
    // If targetLang is 'he', return the value as it is (no translation needed)
    if (targetLang === 'he') {
      return value;
    }
  
    // Always use Hebrew ('he') as the source language
    const sourceLang = 'he';
  
    // Find the Hebrew direction in the translations object
    const direction = this.translations[sourceLang][value.trim()] || value;
  
    // Translate to the target language (e.g., 'en' or 'french') or return the original direction if not found
    return this.translations[targetLang]?.[direction] || direction;
  }
}
